import React from "react"
import ReceiptViewHeader from "./ReceiptViewHeader"
import Check from "images/inline/receipt/check2.svg"
import { orderObjectArray } from "util/misc"


export const SetReminderThankyouView = ({ instructions, headline, introCopy, headerImage, instructionsHeader }) => {
    const orderedInstructions = orderObjectArray(instructions)
    return (
      <div className="receipt-view set-reminder-thankyou-view">
        <ReceiptViewHeader headline={headline} introCopy={introCopy} headerImage={headerImage} />
        <div className={`receipt-view-content`}>
          { instructionsHeader && <h3>{instructionsHeader}</h3>}
          {orderedInstructions && (
            <ul className={`receipt-review-checkoff`}>
              {orderedInstructions.map((instruction, index) => {
                const { desc, detailBackgroundClr } = instruction
                const theStyle = {
                  backgroundColor: detailBackgroundClr || "transparent",
                }
                return (
                  <li key={index}>
                    <Check /><div className="receipt-review-checkoff-inside"><span dangerouslySetInnerHTML={{ __html: desc }}></span></div>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      </div>
    )
  }